import { Box, Typography } from '@mui/material';
import { useState } from 'react';

interface CustomToggleSwitchProps {
  initial?: boolean;
  onToggle?: (val: boolean) => void;
  onText?: string;
  offText?: string;
  disabled?: boolean;
}

const CustomToggleSwitch = ({
  initial = true,
  onToggle,
  onText = 'Show',
  offText = 'Hide',
  disabled = false,
}: CustomToggleSwitchProps) => {
  const [isOn, setIsOn] = useState(initial);

  const handleClick = () => {
    if (disabled) return;
    const newVal = !isOn;
    setIsOn(newVal);
    onToggle?.(newVal);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        width: 61,
        height: 22,
        borderRadius: 16,
         backgroundColor: disabled ? '#aaa' : isOn ? '#6267FD' : '#ccc',
        display: 'flex',
        alignItems: 'center',
        padding: '1px',
        cursor: disabled ? '' : 'pointer',
        position: 'relative',
        userSelect: 'none',
      }}
    >
      {/* Text always centered */}
      <Typography
        sx={{
          color: '#fff',
          fontSize: 12,
          fontWeight: 400,
          position: 'absolute',
          left: isOn ? '10%' : '40%',
          textAlign: 'center',
          pointerEvents: 'none',
        }}
      >
        {isOn ? onText : offText}
      </Typography>

      {/* Knob */}
      <Box
        sx={{
          width: 18,
          height: 18,
          borderRadius: '50%',
          backgroundColor: '#fff',
          boxShadow: '0px 2px 4px rgba(0, 35, 11, 0.2)',
          transition: 'transform 0.2s',
          transform: isOn ? 'translateX(39px)' : 'translateX(0px)',
        }}
      />
    </Box>
  );
};

export default CustomToggleSwitch;
